import { ReactNode } from 'react';

import { Card, Container, rem, Stack, Text, Title } from '@mantine/core';

type LegalPageProps = {
  title: string;
  intro: string;
  children?: ReactNode;
};

type LegalSectionProps = {
  heading: string;
  children: ReactNode;
};

export function LegalPage({ title, intro, children }: LegalPageProps) {
  return (
    <Container size="md" py={rem(64)}>
      <Stack gap="md">
        <Title order={1}>{title}</Title>
        <Text size="sm" c="dimmed">
          {intro}
        </Text>
        <Card withBorder padding="lg" radius="md">
          <Stack gap="xl">{children}</Stack>
        </Card>
      </Stack>
    </Container>
  );
}

export function LegalSection({ heading, children }: LegalSectionProps) {
  return (
    <Stack gap="xs">
      <Title order={2} size="h4">
        {heading}
      </Title>
      {children}
    </Stack>
  );
}
